export const indexHero = {
	title: 'Digitalizácia v <br> stavebníctve',
	learnMore: 'Zistiť viac',
	weAreMembers: 'Sme členmi',
};
